import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import FollowUpCommentsCreate from "./FollowUpCommentsCreate";
import FollowUpCommentsList from "./FollowUpCommentsList";

import { FOLLOW_UP_COMMENTS } from "../../../../../../utils/data/models";
import * as dataActions from "../../../../../../utils/data/dataActions";

class FollowUpComments extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.addComment = this.addComment.bind(this);
    this.updateComment = this.updateComment.bind(this);
  }

  componentWillMount() {
    this.props.getData();
  }

  componentWillUnmount() {
    this.props.dataActions.clearDataList(FOLLOW_UP_COMMENTS);
    this.props.reload && this.props.reload();
  }

  addComment(values) {
    const { dataActions, followUpId } = this.props;

    return dataActions
      .createDataItem(FOLLOW_UP_COMMENTS, { value: values.comment, followUpId })
      .then(() => {
        this.props.getData();
      });
  }

  updateComment(values) {
    this.props.dataActions
      .updateDataItem(FOLLOW_UP_COMMENTS, values)
      .then(() => {
        this.props.getData();
      });
  }

  render() {
    const { isArchivedClient, isArchivedMember} = this.props;
    
    const readOnly = isArchivedClient || isArchivedMember;

    return (
      <div className="comments">
        <FollowUpCommentsCreate readOnly={readOnly} addComment={this.addComment} />
        <FollowUpCommentsList
          {...this.props}
          updateComment={this.updateComment}
          readOnly={readOnly}
        />
      </div>
    );
  }
}

FollowUpComments.propTypes = {
  dataActions: PropTypes.object,
  followUpId: PropTypes.number,
  reload: PropTypes.func,
  getData: PropTypes.func,
  isArchivedMember: PropTypes.bool,
  isArchivedClient: PropTypes.bool
};

function mapStateToProps(state) {
  const comments = state.data.followUpComments || {};
  return {
    comments: comments.items || null,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FollowUpComments);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/notes/comments/FollowUpComments.js